import React from "react";
import { useTranslation } from "react-i18next";
import {
    DetailsBlock,
    DetailsHeader,
    DetailsRow,
    Label,
    Value,
} from "src/components/ContinueDealerOffer/Pages/ReviewPage";

interface Props {
    title: string;
    vin: string;
    stock?: string;
    odometer?: number;
}

const VehicleInformation = ({ title, vin, stock, odometer }: Props) => {
    const { t } = useTranslation();

    return (
        <DetailsBlock>
            <DetailsHeader>{t("DealerOffer.ContinueDealerOffer.ReviewPage.VehicleInformation.Header")}</DetailsHeader>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.VehicleInformation.YearMakeModel")}</Label>
                <Value>{title}</Value>
            </DetailsRow>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.VehicleInformation.VIN")}</Label>
                <Value>{vin}</Value>
            </DetailsRow>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.VehicleInformation.Stock")}</Label>
                <Value>{stock}</Value>
            </DetailsRow>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.VehicleInformation.Odometer")}</Label>
                <Value>{odometer}</Value>
            </DetailsRow>
        </DetailsBlock>
    );
};

export default VehicleInformation;
